module.exports = __webpack_public_path__ + "static/media/02_CALCINHA_LATERAL_DRAPEADA_LISA_06.8fbec259.jpg";